export const T = {
  ar: {
    dashboard: "لوحة التحكم",
    conversations: "المحادثات",
    crm: "العملاء",
    marketing: "التسويق",
    support: "الدعم",
    interactiveDemo: "العرض التفاعلي",
    selectIndustry: "اختر القطاع",
    selectIndustryDesc: "اختر القطاع المناسب للعرض التقديمي",
    startDemo: "ابدأ العرض",
    reset: "إعادة",
    search: "ابحث...",
    agents: "الوكلاء",
    demoControls: "تحكم العرض",
    salesFlow: "المبيعات",
    supportFlow: "الدعم",
    marketingFlow: "التسويق",
    complete: "مكتمل",
    changeIndustry: "تغيير القطاع",
    launchCampaign: "إطلاق حملة",
    sendToLatifa: "أرسل للطيفة",
    escalate: "تصعيد",
    notifyManager: "إبلاغ المدير",
    viewCalendar: "عرض التقويم",
    addDeal: "إضافة صفقة",
    pipelineValue: "قيمة الفرص",
    totalTickets: "إجمالي التذاكر",
    resolutionRate: "معدل الحل",
    avgResponse: "متوسط الاستجابة",
    sessionsToday: "الزيارات اليوم",
    conversions: "التحويلات",
    bounceRate: "معدل الارتداد",
    responseTime: "وقت الاستجابة",
    campaigns: "الحملات",
    templates: "القوالب",
    segments: "شرائح العملاء",
    aiSegments: "شرائح ذكية من المحادثات",
    builtByLatifa: "بُنيت تلقائياً بواسطة لطيفة من أنماط المحادثات",
    recommendation: "توصية لطيفة",
    patternDetected: "نمط مكتشف بواسطة خالد",
    metaApproved: "معتمد من Meta",
    metaPending: "قيد مراجعة Meta",
    metaRejected: "مرفوض من Meta",
    createTemplate: "إنشاء قالب",
    submitReview: "إرسال للمراجعة",
    scheduled: "مجدول",
    sent: "مُرسل",
    draft: "مسودة",
    opened: "فتح",
    responded: "رد",
    contacts: "جهة اتصال",
    new: "جديد",
    qualified: "مؤهل",
    proposal: "عرض سعر",
    negotiation: "تفاوض",
    won: "مكسوبة",
    lost: "خسرناها",
    open: "مفتوح",
    resolved: "تم الحل",
    escalated: "مُصعّد",
    positive: "إيجابي",
    neutral: "محايد",
    negative: "سلبي",
    cancel: "إلغاء",
    confirm: "تأكيد",
    done: "تم",
    recentActivity: "النشاط الأخير",
    activeConversations: "محادثات نشطة",
    openTickets: "تذاكر مفتوحة",
    campaignPerformance: "أداء الحملات",
    letsConnect: "خلنا نوصّلك",
    letsConnectDesc: "أدخل رقمك عشان تجرّب AIDA مباشرة على الواتساب",
    yourPhone: "رقم جوالك",
    yourName: "اسمك",
    additionalPhone: "رقم مشارك إضافي (اختياري)",
    additionalName: "اسم المشارك (اختياري)",
    anyoneElse: "في أحد ثاني يبي يجرّب؟",
    connectToAida: "اتصل بـ AIDA",
    settingUp: "جاري تجهيز عرضك الشخصي...",
    chooseExperience: "اختر تجربتك",
    tryAsCustomer: "جرّب كعميل",
    tryAsCustomerDesc: "تواصل مع عبدالله عبر الواتساب كأنك عميل. راح يساعدك من الاستفسار الأول حتى الحجز",
    tryAsManager: "جرّب كمدير",
    tryAsManagerDesc: "اسأل AIDA عن أي شي في شركتك — المبيعات، التسويق، الدعم. راح تعطيك المعلومات مباشرة",
    whatsappIncoming: "بتوصلك رسالة واتساب من AIDA خلال ثواني",
    liveDemo: "العرض المباشر",
    customerMode: "وضع العميل",
    managerMode: "وضع المدير",
    sessionTimer: "مدة الجلسة",
    endDemo: "إنهاء العرض",
    extendDemo: "تمديد ١٥ دقيقة",
    switchScenario: "تبديل السيناريو",
    sendCampaign: "أرسل حملة تسويقية",
    endDemoConfirm: "إنهاء العرض التجريبي؟ العميل بيستقبل رسالة وداع",
    demoComplete: "العرض مكتمل",
    demoCompleteDesc: "شكراً لتجربتك AIDA!",
    sessionDuration: "مدة الجلسة",
    messagesExchanged: "الرسائل المتبادلة",
    startNewDemo: "بدء عرض جديد",
    demoBye: "شكراً لتجربتك AIDA! العرض التجريبي انتهى. للاشتراك والبدء بالخدمة الكاملة، تواصل مع فريقنا: sales@tkana.sa",
    demoBlocked: "شكراً لاهتمامك! العرض التجريبي انتهى. للمزيد أو للاشتراك، تواصل مع فريق المبيعات: sales@tkana.sa",
    inquiry: "استفسار",
    qualification: "تأهيل",
    booking: "حجز",
    campaignPush: "حملة تسويقية",
    askingSales: "يسأل عن المبيعات",
    askingMarketing: "يسأل عن التسويق",
    askingSupport: "يسأل عن الدعم",
    pipeline: "خط الأعمال",
    contactsTab: "جهات الاتصال",
    newContact: "عميل جديد",
    editContact: "تعديل العميل",
    allContacts: "جميع جهات الاتصال",
    contactName: "الاسم",
    contactPhone: "الجوال",
    contactTags: "الوسوم",
    addTag: "أضف وسم...",
    createTag: "إنشاء وسم",
    newSegment: "شريحة جديدة",
    editSegment: "تعديل الشريحة",
    segmentName: "اسم الشريحة",
    segmentTags: "الوسوم المطلوبة",
    willBeIn: "سيُضاف إلى شرائح:",
    noSegmentsMatch: "لا توجد شرائح مطابقة",
    saveContact: "حفظ",
    deleteContact: "حذف",
    searchContacts: "ابحث عن عميل...",
    noContacts: "لا توجد جهات اتصال",
    noContactsDesc: "أضف عميلك الأول بالضغط على الزر",
    contactsCount: "جهة اتصال",
    tagRequired: "اختر وسماً على الأقل",
    segmentMembers: "عميل",
    deleteSegmentConfirm: "هل تريد حذف هذه الشريحة؟",
    deleteContactConfirm: "هل تريد حذف هذا العميل؟",
    // Campaign system
    templateName: "اسم القالب",
    templateNameAr: "الاسم بالعربي",
    templateNameEn: "الاسم بالإنجليزي",
    templateCategory: "التصنيف",
    categoryMarketing: "تسويقي",
    categoryUtility: "خدمي",
    templateLang: "اللغة",
    templateType: "نوع القالب",
    textOnly: "نص فقط",
    imageAndText: "صورة + نص",
    messageBody: "نص الرسالة",
    addVariable: "إضافة متغير",
    variableName: "الاسم",
    variablePhone: "الجوال",
    variableCustom: "مخصص",
    uploadImage: "رفع صورة",
    submitToMeta: "إرسال لـ Meta للمراجعة",
    templatePreview: "معاينة القالب",
    campaignName: "اسم الحملة",
    campaignNameAr: "الاسم بالعربي",
    campaignNameEn: "الاسم بالإنجليزي",
    selectTemplate: "اختر قالب",
    approvedOnly: "القوالب المعتمدة فقط",
    audience: "الجمهور",
    bySegment: "حسب الشريحة",
    byTags: "حسب الوسوم",
    byCustomers: "حسب العملاء",
    selectSegment: "اختر شريحة",
    selectTags: "اختر الوسوم",
    matchingContacts: "جهة اتصال مطابقة",
    schedule: "الجدولة",
    sendNow: "إرسال الآن",
    scheduleFor: "جدولة لوقت",
    launchCampaignBtn: "إطلاق الحملة",
    noApprovedTemplates: "لا توجد قوالب معتمدة بعد",
    templateSubmitted: "تم إرسال القالب للمراجعة",
    campaignLaunched: "تم إطلاق الحملة بنجاح",
    campaignScheduled: "تم جدولة الحملة بنجاح",
    createNewTemplate: "إنشاء قالب جديد",
    close: "إغلاق",
    // Tags
    tagsTab: "الوسوم",
    newTag: "وسم جديد",
    editTag: "تعديل الوسم",
    deleteTag: "حذف الوسم",
    mergeTag: "دمج الوسوم",
    tagUsage: "مستخدم",
    colorPicker: "اختر لون",
    confirmDeleteTag: "حذف هذا الوسم؟ سيتأثر",
    mergeInto: "دمج في",
    searchTags: "بحث في الوسوم...",
    renameTag: "إعادة تسمية",
    changeColor: "تغيير اللون",
    mergeWith: "دمج مع...",
    createSmartGroupFromTag: "إنشاء مجموعة ذكية من الوسم",
    // Groups
    groupsTab: "المجموعات",
    newGroup: "مجموعة جديدة",
    editGroup: "تعديل المجموعة",
    deleteGroup: "حذف المجموعة",
    staticGroup: "مجموعة ثابتة",
    smartGroup: "مجموعة ذكية",
    filterAll: "الكل",
    filterStatic: "ثابتة",
    filterSmart: "ذكية",
    lastBroadcast: "آخر بث",
    noBroadcastYet: "لا يوجد بث بعد",
    autoUpdated: "تحديث تلقائي",
    editConditions: "تعديل الشروط",
    rename: "إعادة تسمية",
    addMembers: "إضافة أعضاء",
    removeMembers: "إزالة أعضاء",
    groupMembers: "الأعضاء",
    groupDescription: "الوصف",
    groupType: "نوع المجموعة",
    viewMembers: "عرض الأعضاء",
    backToGroups: "رجوع للمجموعات",
    noGroups: "لا توجد مجموعات بعد",
    noGroupsDesc: "أنشئ مجموعتك الأولى",
    addToGroup: "أضف لمجموعة",
    // Smart Groups
    conditionBuilder: "منشئ الشروط",
    addCondition: "إضافة شرط",
    addConditionGroup: "إضافة مجموعة شروط",
    saveAsSmartGroup: "حفظ كمجموعة ذكية",
    matchAll: "مطابقة الكل",
    matchAny: "مطابقة أي",
    field: "الحقل",
    operator: "العملية",
    value: "القيمة",
    includes: "يحتوي",
    doesNotInclude: "لا يحتوي",
    startsWith: "يبدأ بـ",
    contains: "يحتوي على",
    memberOf: "عضو في",
    notMemberOf: "ليس عضو في",
    tagField: "الوسم",
    groupField: "المجموعة",
    phoneField: "الجوال",
    nameField: "الاسم",
    matchingContactsCount: "جهة اتصال مطابقة",
    // Table enhancements
    bulkActions: "إجراءات جماعية",
    selectAll: "تحديد الكل",
    deleteSelected: "حذف المحدد",
    assignTags: "تعيين وسوم",
    selected: "محدد",
    page: "صفحة",
    perPage: "لكل صفحة",
    sortBy: "ترتيب حسب",
    filters: "تصفية",
    clearFilters: "مسح التصفية",
    removeFromGroup: "إزالة من المجموعة",
    contactConversations: "المحادثات",
    contactLastActive: "آخر نشاط",
    justNow: "الآن",
    minAgo: "د",
    hoursAgo: "س",
    yesterday: "أمس",
    daysAgo: "يوم",
    noResults: "لا توجد نتائج",
    // Profile
    conversationsTab: "المحادثات",
    quickActions: "إجراءات سريعة",
    createDeal: "إنشاء صفقة",
    groups: "المجموعات",
    smartGroups: "المجموعات الذكية",
    // Customer Profile (PLT-1363)
    customerSince: "عميل منذ",
    ticket: "تذكرة",
    startConversation: "بدء محادثة",
    activity: "النشاط",
    activityTab: "النشاط",
    all: "الكل",
    tags: "الوسوم",
    broadcasts: "البث",
    today: "اليوم",
    thisWeek: "هذا الأسبوع",
    customerFor: "عميل منذ",
    writeNote: "اكتب ملاحظة...",
    addNote: "أضف ملاحظة",
    editNote: "تعديل",
    deleteNote: "حذف",
    active: "نشط",
    whatsapp: "واتساب",
    sms: "رسالة نصية",
    email: "بريد إلكتروني",
    conversationSubject: "الموضوع",
    noActivity: "لا يوجد نشاط بعد",
    loadOlderConversations: "تحميل محادثات أقدم",
    noConversations: "لا توجد محادثات",
    noNotesYet: "لا توجد ملاحظات بعد",
    // Inbox / Conversations
    myInbox: "صندوقي",
    unassigned: "غير مُسند",
    allConversations: "جميع المحادثات",
    spam: "بريد مزعج",
    channels: "القنوات",
    labels: "التصنيفات",
    customViews: "عروض مخصصة",
    createLabel: "إنشاء تصنيف",
    createView: "إنشاء عرض",
    // Channel names
    whatsappChannel: "واتساب",
    emailChannel: "بريد إلكتروني",
    smsChannel: "رسالة نصية",
    webChat: "محادثة الويب",
    // Status
    statusActive: "نشط",
    statusResolved: "تم الحل",
    statusEscalated: "مُصعّد",
    // Composer
    reply: "رد",
    internalNote: "ملاحظة داخلية",
    noteHelperText: "ملاحظة داخلية — غير مرئية للعميل",
    typeMessage: "اكتب رسالة...",
    sendMessage: "إرسال",
    // Detail panel
    customerInfo: "معلومات العميل",
    assignedTo: "مُسند إلى",
    reassign: "إعادة إسناد",
    changeStatus: "تغيير الحالة",
    relatedTickets: "التذاكر المرتبطة",
    createTicket: "إنشاء تذكرة",
    viewInCrm: "عرض في العملاء",
    customerSinceLabel: "عميل منذ",
    noTickets: "لا توجد تذاكر",
    // Chat
    aiAutoReply: "رد آلي من الذكاء الاصطناعي",
    aiHandoff: "تم التحويل للوكيل البشري",
    loadOlderMessages: "تحميل رسائل أقدم",
    todayLabel: "اليوم",
    yesterdayLabel: "أمس",
    // Labels
    labelUrgent: "عاجل",
    labelFollowUp: "متابعة",
    labelVip: "مهم",
    labelNewLead: "عميل جديد",
    labelEscalated: "مصعّد",
  },
  en: {
    dashboard: "Dashboard",
    conversations: "Conversations",
    crm: "CRM",
    marketing: "Marketing",
    support: "Support",
    interactiveDemo: "Interactive Demo",
    selectIndustry: "Select Industry",
    selectIndustryDesc: "Choose the industry for this demo",
    startDemo: "Start Demo",
    reset: "Reset",
    search: "Search...",
    agents: "Agents",
    demoControls: "Demo Controls",
    salesFlow: "Sales Flow",
    supportFlow: "Support Flow",
    marketingFlow: "Marketing Flow",
    complete: "Complete",
    changeIndustry: "Change Industry",
    launchCampaign: "Launch Campaign",
    sendToLatifa: "Send to Latifa",
    escalate: "Escalate",
    notifyManager: "Notify Manager",
    viewCalendar: "View Calendar",
    addDeal: "Add Deal",
    pipelineValue: "Pipeline Value",
    totalTickets: "Total Tickets",
    resolutionRate: "Resolution Rate",
    avgResponse: "Avg Response",
    sessionsToday: "Sessions Today",
    conversions: "Conversions",
    bounceRate: "Bounce Rate",
    responseTime: "Response Time",
    campaigns: "Campaigns",
    templates: "Templates",
    segments: "Customer Segments",
    aiSegments: "AI-Generated Segments",
    builtByLatifa: "Built automatically by Latifa from conversation patterns",
    recommendation: "Latifa's Recommendation",
    patternDetected: "Pattern Detected by Khalid",
    metaApproved: "Meta Approved",
    metaPending: "Meta Pending Review",
    metaRejected: "Meta Rejected",
    createTemplate: "Create Template",
    submitReview: "Submit for Review",
    scheduled: "Scheduled",
    sent: "Sent",
    draft: "Draft",
    opened: "Opened",
    responded: "Responded",
    contacts: "contacts",
    new: "New",
    qualified: "Qualified",
    proposal: "Proposal",
    negotiation: "Negotiation",
    won: "Won",
    lost: "Lost",
    open: "Open",
    resolved: "Resolved",
    escalated: "Escalated",
    positive: "Positive",
    neutral: "Neutral",
    negative: "Negative",
    cancel: "Cancel",
    confirm: "Confirm",
    done: "Done",
    recentActivity: "Recent Activity",
    activeConversations: "Active Conversations",
    openTickets: "Open Tickets",
    campaignPerformance: "Campaign Performance",
    letsConnect: "Let's Get You Connected",
    letsConnectDesc: "Enter your number to try AIDA live on WhatsApp",
    yourPhone: "Your Phone Number",
    yourName: "Your Name",
    additionalPhone: "Additional Participant (optional)",
    additionalName: "Participant Name (optional)",
    anyoneElse: "Anyone else want to try?",
    connectToAida: "Connect to AIDA",
    settingUp: "Setting up your personalized demo...",
    chooseExperience: "Choose Your Experience",
    tryAsCustomer: "Try as Customer",
    tryAsCustomerDesc: "Chat with Abdullah on WhatsApp as a customer. He'll help you from first inquiry to booking.",
    tryAsManager: "Try as Manager",
    tryAsManagerDesc: "Ask AIDA anything about your business — sales, marketing, support. Get instant intelligence.",
    whatsappIncoming: "You'll receive a WhatsApp message from AIDA in a few seconds",
    liveDemo: "Live Demo",
    customerMode: "Customer Mode",
    managerMode: "Manager Mode",
    sessionTimer: "Session Duration",
    endDemo: "End Demo",
    extendDemo: "Extend 15 min",
    switchScenario: "Switch Scenario",
    sendCampaign: "Send Marketing Campaign",
    endDemoConfirm: "End this demo? Prospect will receive a farewell message.",
    demoComplete: "Demo Complete",
    demoCompleteDesc: "Thanks for trying AIDA!",
    sessionDuration: "Session Duration",
    messagesExchanged: "Messages Exchanged",
    startNewDemo: "Start New Demo",
    demoBye: "Thanks for trying AIDA! Your demo session has ended. To subscribe, contact our team: sales@tkana.sa",
    demoBlocked: "Thanks for your interest! Demo has ended. For more info or to subscribe, contact sales: sales@tkana.sa",
    inquiry: "Inquiry",
    qualification: "Qualification",
    booking: "Booking",
    campaignPush: "Campaign Push",
    askingSales: "Asking about Sales",
    askingMarketing: "Asking about Marketing",
    askingSupport: "Asking about Support",
    pipeline: "Pipeline",
    contactsTab: "Contacts",
    newContact: "New Contact",
    editContact: "Edit Contact",
    allContacts: "All Contacts",
    contactName: "Name",
    contactPhone: "Phone",
    contactTags: "Tags",
    addTag: "Add tag...",
    createTag: "Create tag",
    newSegment: "New Segment",
    editSegment: "Edit Segment",
    segmentName: "Segment Name",
    segmentTags: "Required Tags",
    willBeIn: "Will be in segments:",
    noSegmentsMatch: "No matching segments",
    saveContact: "Save",
    deleteContact: "Delete",
    searchContacts: "Search contacts...",
    noContacts: "No contacts yet",
    noContactsDesc: "Add your first contact using the button above",
    contactsCount: "contacts",
    tagRequired: "Select at least one tag",
    segmentMembers: "members",
    deleteSegmentConfirm: "Delete this segment?",
    deleteContactConfirm: "Delete this contact?",
    // Campaign system
    templateName: "Template Name",
    templateNameAr: "Name (Arabic)",
    templateNameEn: "Name (English)",
    templateCategory: "Category",
    categoryMarketing: "Marketing",
    categoryUtility: "Utility",
    templateLang: "Language",
    templateType: "Template Type",
    textOnly: "Text Only",
    imageAndText: "Image + Text",
    messageBody: "Message Body",
    addVariable: "Add Variable",
    variableName: "Name",
    variablePhone: "Phone",
    variableCustom: "Custom",
    uploadImage: "Upload Image",
    submitToMeta: "Submit to Meta for Review",
    templatePreview: "Template Preview",
    campaignName: "Campaign Name",
    campaignNameAr: "Name (Arabic)",
    campaignNameEn: "Name (English)",
    selectTemplate: "Select Template",
    approvedOnly: "Approved templates only",
    audience: "Audience",
    bySegment: "By Segment",
    byTags: "By Tags",
    byCustomers: "By Customers",
    selectSegment: "Select Segment",
    selectTags: "Select Tags",
    matchingContacts: "matching contacts",
    schedule: "Schedule",
    sendNow: "Send Now",
    scheduleFor: "Schedule For",
    launchCampaignBtn: "Launch Campaign",
    noApprovedTemplates: "No approved templates yet",
    templateSubmitted: "Template submitted for review",
    campaignLaunched: "Campaign launched successfully",
    campaignScheduled: "Campaign scheduled successfully",
    createNewTemplate: "Create New Template",
    close: "Close",
    // Tags
    tagsTab: "Tags",
    newTag: "New Tag",
    editTag: "Edit Tag",
    deleteTag: "Delete Tag",
    mergeTag: "Merge Tags",
    tagUsage: "used",
    colorPicker: "Pick Color",
    confirmDeleteTag: "Delete this tag? Will affect",
    mergeInto: "Merge into",
    searchTags: "Search tags...",
    renameTag: "Rename",
    changeColor: "Change color",
    mergeWith: "Merge with...",
    createSmartGroupFromTag: "Create Smart Group from tag",
    // Groups
    groupsTab: "Groups",
    newGroup: "New Group",
    editGroup: "Edit Group",
    deleteGroup: "Delete Group",
    staticGroup: "Static Group",
    smartGroup: "Smart Group",
    filterAll: "All",
    filterStatic: "Static",
    filterSmart: "Smart",
    lastBroadcast: "Last broadcast",
    noBroadcastYet: "No broadcasts yet",
    autoUpdated: "auto-updated",
    editConditions: "Edit conditions",
    rename: "Rename",
    addMembers: "Add Members",
    removeMembers: "Remove Members",
    groupMembers: "Members",
    groupDescription: "Description",
    groupType: "Group Type",
    viewMembers: "View Members",
    backToGroups: "Back to Groups",
    noGroups: "No groups yet",
    noGroupsDesc: "Create your first group",
    addToGroup: "Add to Group",
    // Smart Groups
    conditionBuilder: "Condition Builder",
    addCondition: "Add Condition",
    addConditionGroup: "Add Condition Group",
    saveAsSmartGroup: "Save as Smart Group",
    matchAll: "Match All",
    matchAny: "Match Any",
    field: "Field",
    operator: "Operator",
    value: "Value",
    includes: "includes",
    doesNotInclude: "does not include",
    startsWith: "starts with",
    contains: "contains",
    memberOf: "member of",
    notMemberOf: "not member of",
    tagField: "Tag",
    groupField: "Group",
    phoneField: "Phone",
    nameField: "Name",
    matchingContactsCount: "matching contacts",
    // Table enhancements
    bulkActions: "Bulk Actions",
    selectAll: "Select All",
    deleteSelected: "Delete Selected",
    assignTags: "Assign Tags",
    selected: "selected",
    page: "Page",
    perPage: "per page",
    sortBy: "Sort by",
    filters: "Filters",
    clearFilters: "Clear Filters",
    removeFromGroup: "Remove from Group",
    contactConversations: "Conversations",
    contactLastActive: "Last Active",
    justNow: "just now",
    minAgo: "min ago",
    hoursAgo: "hours ago",
    yesterday: "Yesterday",
    daysAgo: "days ago",
    noResults: "No results",
    // Profile
    conversationsTab: "Conversations",
    quickActions: "Quick Actions",
    createDeal: "Create Deal",
    groups: "Groups",
    smartGroups: "Smart Groups",
    // Customer Profile (PLT-1363)
    customerSince: "Customer since",
    ticket: "Ticket",
    startConversation: "Start Conversation",
    activity: "Activity",
    activityTab: "Activity",
    all: "All",
    tags: "Tags",
    broadcasts: "Broadcasts",
    today: "Today",
    thisWeek: "This Week",
    customerFor: "Customer for",
    writeNote: "Write a note...",
    addNote: "Add Note",
    editNote: "Edit",
    deleteNote: "Delete",
    active: "Active",
    whatsapp: "WhatsApp",
    sms: "SMS",
    email: "Email",
    conversationSubject: "Subject",
    noActivity: "No activity yet",
    loadOlderConversations: "Load older conversations",
    noConversations: "No conversations",
    noNotesYet: "No notes yet",
    // Inbox / Conversations
    myInbox: "My Inbox",
    unassigned: "Unassigned",
    allConversations: "All Conversations",
    spam: "Spam",
    channels: "Channels",
    labels: "Labels",
    customViews: "Custom Views",
    createLabel: "Create Label",
    createView: "Create View",
    // Channel names
    whatsappChannel: "WhatsApp",
    emailChannel: "Email",
    smsChannel: "SMS",
    webChat: "Web Chat",
    // Status
    statusActive: "Active",
    statusResolved: "Resolved",
    statusEscalated: "Escalated",
    // Composer
    reply: "Reply",
    internalNote: "Internal Note",
    noteHelperText: "Internal note — not visible to customer",
    typeMessage: "Type a message...",
    sendMessage: "Send",
    // Detail panel
    customerInfo: "Customer Info",
    assignedTo: "Assigned to",
    reassign: "Reassign",
    changeStatus: "Change Status",
    relatedTickets: "Related Tickets",
    createTicket: "Create Ticket",
    viewInCrm: "View in CRM",
    customerSinceLabel: "Customer since",
    noTickets: "No tickets",
    // Chat
    aiAutoReply: "AI Auto-Reply",
    aiHandoff: "AI transferred to human agent",
    loadOlderMessages: "Load older messages",
    todayLabel: "Today",
    yesterdayLabel: "Yesterday",
    // Labels
    labelUrgent: "Urgent",
    labelFollowUp: "Follow-up",
    labelVip: "VIP",
    labelNewLead: "New Lead",
    labelEscalated: "Escalated",
  },
};
